export default "__VITE_ASSET__AraHwCRb__"